export default __webpack_public_path__ + "assets/images/4d3e02838b2cdd611e8fde5a80b6c51e.png";